import React from 'react'
import PropTypes from 'prop-types'

export const PdfViewer = ({ data }) => {
  if (data) {
    return (
      <object
        type="application/pdf"
        data={data}
        width="100%"
        height="700"
      ></object>
    )
  }

  return null
}

PdfViewer.propTypes = {
  data: PropTypes.string,
}

PdfViewer.defaultProps = {
  data: null,
}

export default PdfViewer
